(() => {
  const SELECTOR = 'details-modal.header__search';

  const dispatch = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  };

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((modal) => {
      if (modal.dataset.tzSearchInitialized === 'true') return;
      modal.dataset.tzSearchInitialized = 'true';

      const details = modal.querySelector('details');
      const shell = modal.querySelector('.tz-search-shell');
      const input = modal.querySelector('input[type="search"]');
      const form = modal.querySelector('form[role="search"]');

      const syncQueryState = () => {
        const hasQuery = Boolean(input?.value?.trim());
        shell?.classList.toggle('is-querying', hasQuery);
      };

      details?.addEventListener('toggle', () => {
        if (details.open) {
          syncQueryState();
          dispatch('treezyn:search:opened', { query: input?.value?.trim() || '' });
        } else {
          dispatch('treezyn:search:closed', { query: input?.value?.trim() || '' });
        }
      });

      input?.addEventListener('input', syncQueryState);
      input?.addEventListener('search', syncQueryState);
      form?.addEventListener('reset', () => requestAnimationFrame(syncQueryState));

      modal.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-tz-search-result]');
        if (!link) return;

        dispatch('treezyn:search:result:selected', {
          type: link.dataset.resultType || 'link',
          title: link.dataset.resultTitle || link.textContent.trim(),
          url: link.getAttribute('href'),
          query: input?.value?.trim() || '',
        });
      });

      syncQueryState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();
